import * as React from 'react'
import { useAuth0 } from '@auth0/auth0-react'
import { useLocation } from 'react-router-dom'
import { useIdentifyUser, usePageView, useGroup } from 'Hooks/useAnalytics'
import { useAppState } from 'Context/AppContext/AppContext'
import useConfigureActivePlans from 'Hooks/useConfigureActivePlans/useConfigureActivePlans'
import {
  UseGroupParams,
  UseIdentifyUserParams,
} from 'Hooks/useAnalytics/useAnalytics'
import { useDetectAdblockerEvent } from 'Hooks/useDetectAdblockerEvent/useDetectAdblockerEvent'

const Analytics = (): JSX.Element => {
  const { nonprofitOrgConfig, funderOrgConfig, userConfig } = useAppState()
  const { isFunderUser } = useConfigureActivePlans()
  const { user, isAuthenticated } = useAuth0()
  const location = useLocation()

  usePageView(location)
  useDetectAdblockerEvent()

  const userToIdentify: UseIdentifyUserParams = isFunderUser
    ? {
        userId: userConfig.id,
        email: user?.email,
        isAuthenticated,
        option: userConfig,
        nonprofitOrgId: null,
        funderOrgId: funderOrgConfig.orgId,
      }
    : {
        userId: userConfig.id,
        email: user?.email,
        isAuthenticated,
        option: userConfig,
        nonprofitOrgId: nonprofitOrgConfig?.orgId,
        funderOrgId: null,
      }

  useIdentifyUser(userToIdentify)

  const groupToIdentify: UseGroupParams = isFunderUser
    ? {
        groupId: funderOrgConfig?.orgId,
        formationPlan: null,
        platformPlan: null,
        orgName: funderOrgConfig?.orgName,
        platform: 'funder',
        platformPlanAddOns: [],
      }
    : {
        groupId: nonprofitOrgConfig?.orgId,
        formationPlan: nonprofitOrgConfig?.formationPlan,
        platformPlan: nonprofitOrgConfig?.platformPlan,
        orgName: nonprofitOrgConfig?.orgName,
        platform: 'nonprofit',
        platformPlanAddOns: nonprofitOrgConfig?.platformPlanAddOns,
      }

  useGroup(groupToIdentify)

  return <> </>
}

export default Analytics
